//TODO: add the request body object modal for the api endpoints which have no parameters
export default {
  getOverviewList: 'GetOverview',
  searchClients: 'SearchCustomers', //TODO: Make naming consistent either "Customer" or "Client"
  exportClientOverview: 'ExportClientOverview?ShowInactiveClients={showInactiveClients}', //TODO: Make naming consistent either "Customer" or "Client"
  exportOrganizations: 'ExportOrganizations?ShowInactiveClients={showInactiveClients}',
  exportContacts: 'ExportContacts?ShowInactiveClients={showInactiveClients}'
}
